"use client";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import type React from "react";
import { useCreateStripeSession } from "@/features/settings/api/create-stripe-session";
import type { PaywallType } from "@/lib/hooks/use-pricing-modal";
import type { PlanType } from "@/lib/types";
import { useAuth } from "./providers/auth-context";
import { Button } from "./ui/button";

interface UpgradeButtonProps {
  isSubscribed?: boolean;
  plan: PlanType;
  studySetId?: string;
  children: React.ReactNode;
  className?: string;
  paywallType?: PaywallType;
}

const UpgradeButton = ({
  plan = "monthly",
  studySetId,
  children,
  className,
  paywallType,
  isSubscribed,
}: UpgradeButtonProps) => {
  const { userId } = useAuth();
  const pathname = usePathname();

  const { mutate: createStripeSession } = useCreateStripeSession();
  return (
    <Button
      className={className}
      onClick={() =>
        createStripeSession(
          { plan, studySetId, returnUrl: pathname },
          {
            onSuccess: () => {
              posthog.capture("clicked_upgrade/create_stripe_session_button", {
                userId,
                plan,
                studySetId,
                paywallType,
                isSubscribed,
              });
            },
          },
        )
      }
      size="sm"
    >
      {children}
    </Button>
  );
};

export default UpgradeButton;
